import { useNavigate } from "react-router-dom";

import "./no-child.sass";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const NoChild = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("dashboard");

  const handleClick = () => {
    navigate(
      {
        pathname: "/sign-up-child"
      },
      {
        state: {
          fromDashboard: true
        }
      }
    );
  };

  return (
    <div className="no-child">
      <Typography variant="h2">{t("noChildMessage")}</Typography>
      <p className="no-child-message">{t("noChildSetupMessage")}</p>
      <Button size="large" onClick={handleClick}>
        {t("addChild", { ns: "common" })}
      </Button>
    </div>
  );
};

export default NoChild;
